module.exports = __webpack_public_path__ + "static/media/box3.fa1643c0.jpg";